// extracted by mini-css-extract-plugin
export default {"root":"MemoryRangeV1_root-lbO","range":"MemoryRangeV1_range-fSo","ends":"MemoryRangeV1_ends-SRQ"};